// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1Tgk-","active":"NavigationItem_active__2Vegb","spacer":"NavigationItem_spacer__4nkhf"};